 export const environment = {
    bardWoodUrl : "https://bardwoodutils.reca.ai/bardwood/"
}